<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-left">
        <div class="brand">
          <div class="brand-logo">易才保险经纪</div>
          <div class="brand-slogan">企业综合福利保险服务平台</div>
        </div>
        <div class="brand-features">
          <div class="feature-item">
            <span class="feature-dot"></span>
            <span>严选优质保险产品</span>
          </div>
          <div class="feature-item">
            <span class="feature-dot"></span>
            <span>在线投保，便捷高效</span>
          </div>
          <div class="feature-item">
            <span class="feature-dot"></span>
            <span>专业客服贴心服务</span>
          </div>
        </div>
      </div>

      <div class="login-right">
        <div class="login-box">
          <h2 class="login-title">账号登录</h2>
          <p class="login-subtitle">欢迎回来，请输入您的账号信息</p>

          <v-form ref="form" lazy-validation v-model="formValid" @submit.prevent="login">
            <div class="form-item">
              <label class="form-label">手机号</label>
              <input
                v-model="form.loginName"
                type="text"
                class="form-input"
                placeholder="请输入手机号"
                maxlength="11"
                @blur="onPhoneBlur"
                @keyup.enter="login"
              />
            </div>

            <div class="form-item">
              <label class="form-label">密码</label>
              <div class="form-field">
                <input
                  v-model="form.password"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-input"
                  placeholder="请输入密码"
                  maxlength="20"
                  @keyup.enter="login"
                />
                <span class="form-toggle" @click="showPassword = !showPassword">
                  {{ showPassword ? '隐藏' : '显示' }}
                </span>
              </div>
            </div>

            <div class="form-item">
              <label class="form-label">验证码</label>
              <div class="form-field code-field">
                <input
                  v-model="form.captcha"
                  type="text"
                  class="form-input"
                  placeholder="请输入验证码"
                  maxlength="4"
                  @keyup.enter="login"
                />
                <div class="captcha-img" @click="getCaptcha">
                  <img v-if="captchaBase64" :src="captchaBase64" alt="验证码" />
                  <span v-else>点击获取</span>
                </div>
              </div>
            </div>

            <div v-if="errorMsg" class="login-error">{{ errorMsg }}</div>

            <button class="login-btn" :disabled="loading" @click="login">
              <span v-if="!loading">登 录</span>
              <span v-else>登录中...</span>
            </button>

            <div class="login-footer">
              <span class="footer-text">还没有账号？</span>
              <a class="footer-link" @click="goRegister">立即注册</a>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import validate from "@/assets/js/validate";
import { cusLogin, getCaptchaCode } from "@/api/travelInsurance";
import md5 from "js-md5";

export default {
  name: "LoginPage",
  data() {
    return {
      form: {
        loginName: "",
        password: "",
        captcha: ""
      },
      errorMsg: "",
      loading: false,
      showPassword: false,
      formValid: true,
      captchaBase64: ""
    };
  },
  created() {
    // 已登录则直接跳转
    if (this.$store.state.loginStatus) {
      this.handleRedirect();
      return;
    }
  },
  watch: {
    "form.loginName"(val) {
      if (val && validate.isMobilePhone(val) && !this.captchaBase64) {
        this.getCaptcha();
      }
    }
  },
  methods: {
    // 表单校验
    validateForm() {
      if (!this.form.loginName) {
        this.$message.error("请输入手机号");
        return false;
      }
      if (!validate.isMobilePhone(this.form.loginName)) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      if (!this.form.password) {
        this.$message.error("请输入密码");
        return false;
      }
      if (!validate.isPassword(this.form.password)) {
        this.$message.error("密码格式错误，只能包含6-20位数字、字母、下划线");
        return false;
      }
      if (!this.form.captcha) {
        this.$message.error("请输入验证码");
        return false;
      }
      if (!/^[a-zA-Z0-9]{4}$/.test(this.form.captcha)) {
        this.$message.error("请输入4位验证码");
        return false;
      }
      return true;
    },
    // 登录
    login() {
      if (this.loading) return;
      if (!this.validateForm()) return;
      this.errorMsg = "";
      this.loading = true;

      cusLogin({
        cusName: this.form.loginName,
        password: md5(this.form.password),
        captcha: this.form.captcha
      })
        .then(res => {
          this.loading = false;
          if (res && res.code === 0) {
            // 保存登录状态
            this.$store.commit("setLogin", res.data);
            this.handleRedirect();
          } else {
            this.errorMsg = (res && res.msg) || "登录失败，请重试";
            this.getCaptcha();
          }
        })
        .catch(err => {
          this.loading = false;
          this.errorMsg = (err && err.message) || "登录失败，请重试";
          this.getCaptcha();
        });
    },
    // 手机号失焦后自动加载验证码
    onPhoneBlur() {
      // if (this.form.loginName && validate.isMobilePhone(this.form.loginName) && !this.captchaBase64) {
      //   this.getCaptcha();
      // }
    },
    // 获取图片验证码
    getCaptcha() {
      if (!this.form.loginName) {
        this.$message.error("请输入手机号");
        return;
      }
      getCaptchaCode(this.form.loginName).then(res => {
          if(res && res.code === 0){
            let base64 = res.data;
            if (base64 && typeof base64 === "string" && !base64.startsWith("data:image")) {
              base64 = "data:image/png;base64," + base64;
            }
            this.captchaBase64 = base64 || "";
            this.form.captcha = "";
          }   
        })
        .catch(() => {
          this.captchaBase64 = "";
          this.form.captcha = "";
        });
    },
    // 处理登录成功后的跳转
    handleRedirect() {
      const redirect = this.$route.query.redirect;
      if (
        redirect &&
        redirect.startsWith("/") &&
        !redirect.startsWith("//")
      ) {
        this.$router.replace(redirect);
        return;
      }
      this.$router.replace({ name: "home" });
    },
    // 跳转到注册页
    goRegister() {
      const redirect = this.$route.query.redirect;
      this.$router.push({
        path: "/register",
        query: redirect ? { redirect } : {}
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-page {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8edf5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.login-container {
  display: flex;
  width: 920px;
  max-width: 100%;
  min-height: 540px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* ============ 左侧品牌区 ============ */
.login-left {
  flex: 1;
  background: linear-gradient(180deg, #dd122a 0%, #ff7a8a 60%, #ffb3bd 100%);
  color: #ffffff;
  padding: 60px 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.brand {
  &-logo {
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 2px;
    margin-bottom: 12px;
  }
  &-slogan {
    font-size: 15px;
    opacity: 0.85;
  }
}

.brand-features {
  .feature-item {
    display: flex;
    align-items: center;
    font-size: 15px;
    margin-bottom: 16px;
    opacity: 0.95;

    &:last-child {
      margin-bottom: 0;
    }
  }
  .feature-dot {
    width: 6px;
    height: 6px;
    background: #ffffff;
    border-radius: 50%;
    margin-right: 12px;
    flex-shrink: 0;
  }
}

/* ============ 右侧登录表单 ============ */
.login-right {
  flex: 1;
  padding: 60px 60px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.login-box {
  width: 100%;
  max-width: 360px;
}

.login-title {
  font-size: 26px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px;
}

.login-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0 0 32px;
}

.form-item {
  margin-bottom: 20px;
  position: relative;
}

.form-field {
  position: relative;
  width: 100%;
}

.form-label {
  display: block;
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  font-size: 14px;
  color: #303133;
  background: #f5f7fa;
  border: 1px solid transparent;
  border-radius: 6px;
  outline: none;
  box-sizing: border-box;
  transition: all 0.2s;

  &:focus {
    background: #ffffff;
    border-color: #dd122a;
  }
  &::placeholder {
    color: #c0c4cc;
  }
}

.code-field {
  display: flex;
  gap: 10px;

  .form-input {
    flex: 1;
  }

  .captcha-img {
    width: 110px;
    height: 44px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    user-select: none;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    span {
      font-size: 13px;
      color: #909399;
    }
  }
}

.form-toggle {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 13px;
  color: #dd122a;
  cursor: pointer;
  user-select: none;
  line-height: 1;
}

.form-error {
  margin-top: 6px;
  font-size: 12px;
  color: #f56c6c;
  line-height: 1.4;
}

.login-error {
  margin-bottom: 16px;
  padding: 8px 12px;
  background: #fef0f0;
  color: #f56c6c;
  font-size: 13px;
  border-radius: 4px;
  text-align: center;
}

.login-btn {
  width: 100%;
  height: 46px;
  margin-top: 10px;
  background: linear-gradient(90deg, #dd122a 0%, #c10f24 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 4px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.92;
    box-shadow: 0 4px 12px rgba(221, 18, 42, 0.3);
  }
  &:active:not(:disabled) {
    transform: scale(0.99);
  }
  &:disabled {
    background: #f0a5ad;
    cursor: not-allowed;
  }
}

.login-footer {
  margin-top: 16px;
  text-align: center;
  font-size: 13px;
  color: #909399;

  .footer-text {
    margin-right: 4px;
  }
  .footer-link {
    color: #dd122a;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* ============ 响应式 ============ */
@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
    min-height: auto;
  }
  .login-left {
    padding: 30px;
  }
  .brand-features {
    display: none;
  }
  .login-right {
    padding: 30px 24px;
  }
}
</style>
